import isDefined from '@afosto/utils/isDefined';

const formatConfiguration = (app, values) => {
  const formattedValues = { ...values };

  if (app?.code === 'afosto') {
    formattedValues.channels = (formattedValues?.channels || []).map(method => ({
      ...method,
      external_service_id: isDefined(method.external_service_id)
        ? parseInt(method.external_service_id, 10)
        : null,
    }));

    formattedValues.shipping_methods = (formattedValues?.shipping_methods || []).map(method => ({
      ...method,
      spid:
        isDefined(method.shipping_method_id) && method.shipping_method_id === 'af_pickup'
          ? method.spid
          : null,
      af_shipping_method_id: isDefined(method.af_shipping_method_id)
        ? parseInt(method.af_shipping_method_id, 10)
        : null,
    }));
  }

  return formattedValues;
};

export default formatConfiguration;
